import { memo, useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ShowCircleIcon from '@components/ShowCircleIcon'
import { px2rem, showNameToSlug } from '@utils'
import { Shows as ShowsService } from '@services'
import { logger, validateAxiosResponse } from '@dmi-mch/utils'

const ShowsInfo = memo(({ className, galleryIsActive, lastExhibitionLabel = 'This gallery last exhibited in', galleryAccountId }) => {
  const [lastActiveShows, setLastActiveShows] = useState([])
  const [visibleShowInfos, setVisibleShowInfos] = useState([])

  const fetchLastActiveShows = useCallback(
    async (didUnmount = false) => {
      try {
        const params = { limit: 3 }
        const req = await ShowsService.getAccountExhibitions(galleryAccountId, params)
        if (!didUnmount && validateAxiosResponse(req)) {
          setLastActiveShows(req.data)
          setVisibleShowInfos(req.data)
        }
      } catch (err) {
        !didUnmount && logger(err)
      }
    },
    [galleryAccountId]
  )

  useEffect(() => {
    let didUnmount = false
    !lastActiveShows.length && fetchLastActiveShows(didUnmount)
    return () => {
      didUnmount = true
    }
  }, [lastActiveShows, fetchLastActiveShows])

  return (
    <div className={className}>
      {!galleryIsActive && visibleShowInfos && visibleShowInfos.length > 0 ? (
        <div className='last-show'>
          {lastExhibitionLabel} {visibleShowInfos[0].name}.
        </div>
      ) : (
        visibleShowInfos.map((info, index) => (
          <div
            key={info.id}
            className={`show-tag text-medium mb-lg-0 ${visibleShowInfos.length - 1 !== index ? 'mb-4' : ''}`}
          >
            <ShowCircleIcon show={info.type && showNameToSlug(info.type).replace('-', '')} />
            {info.name}
          </div>
        ))
      )}
    </div>
  )
})
ShowsInfo.displayName = 'ShowsInfo'

ShowsInfo.propTypes = {
  className: PropTypes.string,
  galleryIsActive: PropTypes.bool,
  lastExhibitionLabel: PropTypes.string,
  galleryAccountId: PropTypes.string
}

export default styled(ShowsInfo)`
  &&& {
    display: flex;
    margin: 32px 0 0;

    @media (max-width: ${global.uikitVars.breakpointSmMax}) {
      flex-direction: column;
    }

    .show-tag {
      margin-right: ${px2rem(20)};

      .show-icon {
        margin-right: ${px2rem(10)};
      }
    }
  }
`
